import { FC } from 'react';
import { Badge } from 'antd';

import style from './index.module.scss';

type TProps = {
  text: string;
};

const SuperviserApproveMarker: FC<TProps> = ({ text }) => {
  return (
    <span className={style.marker}>
      <Badge className={style.badge} status="error" />
      {text}
    </span>
  );
};

export default SuperviserApproveMarker;
